/**
 * Stories implemented
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FC } from 'react';
import { PageSpinnerExperience } from 'src/components/PageSpinnerExperience';

/**
 * Renders a spinner experience while the authentication decision is pending.
 */
export const AuthenticationIsLoading: FC = () => <PageSpinnerExperience />;
